// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  apiUrl: 'https://www.fal.or.th',
  websocketUrl:'ws://www.fal.or.th',
  app_name:'website',
  omise_public_key:'pkey_test_55m70k1xj6d7s0xz502',
  omise_private_key:'skey_test_55m70k1y2ubd5e0dyyj',

};


/*
 * For easier debugging in development mode, you can import the following file`
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
